import * as React from "react";
import { createContext } from "react";

export interface AppContextInterface {
  token: string;
  behaviour: {};
}

export interface TeamsRecipients {
  recipients: [];
}

export const AppCtx = React.createContext<AppContextInterface | null>(null);

export const Recipient = React.createContext<TeamsRecipients | null>(null);
